import { useSelector } from 'react-redux';
import selectors from 'selectors/selectors.js';
import TodoItem from 'screens/todos/TodoItem.js';
import React from 'react';

const NotificationSliderTodos = () => {
  const notificationFolderId = useSelector(selectors.notificationFolderId);
  const notificationSidebarTodosDueToday = useSelector(selectors.notificationSidebarTodosDueToday);
  const notificationSidebarOverdueTodos = useSelector(selectors.notificationSidebarOverdueTodos);
  const data = {
    todosOverdue: notificationSidebarOverdueTodos,
    todos: notificationSidebarTodosDueToday,
  }[notificationFolderId];
  return (
    <>
      {(data || []).map((n, i) => {
        return <TodoItem key={n.id + i} todoId={n.id} displayFull={true} view={'notificationSlider'} />;
      })}
    </>
  );
};

export default NotificationSliderTodos;
